export const TOP_OFFSET = 10;
export const LEFT_OFFSET = 30;

const DEFAULT_FONT_SIZE = 20;
const DEFAULT_FONT_COLOR = 'inherit';
const DEFAULT_FONT_STYLE = 'normal';
const DEFAULT_FONT_WEIGHT = 'normal';
const DEFAULT_TEXT_DECORATION = 'none';

export const PAGE_NUMBER_FONT_FAMILY = 'Inter';

export const DEFAULT_PAGE_NUMBER_STYLE = {
  color: DEFAULT_FONT_COLOR,
  fontSize: DEFAULT_FONT_SIZE,
  fontFamily: PAGE_NUMBER_FONT_FAMILY,
  fontWeight: DEFAULT_FONT_WEIGHT,
  fontStyle: DEFAULT_FONT_STYLE,
  textDecoration: DEFAULT_TEXT_DECORATION,
};
export const EDITABLE_PAGE_NUMBER_ID = 'editable-page-number';
// The main selector for the page number - if this is updated export has to be updated as well
export const PAGE_NUMBER_EXPORT_CLASSNAME = 'page-number-base';
